<template>
  <div class="bg-white p-4">
    <div class="row bg-primary p-3 rounded text-white">
      <div class="col-1">
        <icon :icon="['fad', 'door-open']" class="fa-6x"/>
      </div>
      <div class="col">
        <div class="row">
          <div class="col">
            <h5> Please log in to submit your e-poster.</h5>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col my-auto">
            <div class="form-inline">
              <div class="mb-3">
                <label for="tokenpw" class="sr-only">Your access code:&nbsp;</label>
                <input type="password" id="tokenpw" v-model="token" required class="form-control me-3"
                       aria-describedby="tokenHelp" @focus="error = ''" @keyup.enter="checkUserToken()"
                       placeholder="Token">
                <button class="btn btn-secondary mt-3" v-on:click="checkUserToken()">
                  <icon :icon="['fad', 'lock-open']"/>&nbsp;Login
                </button>
              </div>
            </div>
            <div class="row" v-if="showError">
              <div class="col">
                <div class="alert alert-danger">
                  <div class="row">
                    <div class="col-1">
                      <icon :icon="['fad', 'do-not-enter']" class="fa-2x"/>
                    </div>
                    <div class="col my-auto fw-bold" v-html="errorMsg"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapState, mapActions} from 'vuex'

export default {
  data() {
    return {
      token: '',
      errorMsg: 'The entered token could not be verified, please try again or contact support.',
      showError: false,
      processing: false
    };
  },
  computed: mapState([
    'login', 'prefilledToken'
  ]),
  mounted() {
    if (this.prefilledToken) {
      this.token = this.prefilledToken;
      this.checkUserToken();
    }
  },
  methods: {
    ...mapActions(['CHECK_LOGIN']),
    getLoginUrl() {
      // return process.env.VUE_APP_AUTH_URL + 'application/' + process.env.VUE_APP_AUTH_KEY;
    },
    async checkUserToken() {
      this.processing = true;
      await this.CHECK_LOGIN(this.token).then((result) => {
        this.processing = false;
        this.$set(this.$store.state.login, 'success', true);
        this.$set(this.$store.state, 'usermapping', true);
        this.$store.commit("SET_TOKEN", {"token": result.data})
        localStorage.setItem('eposter-token', this.token);
        localStorage.setItem('x-api-key', result.data);
        this.$router.push('/home');
      }).catch((errorRev) => {
        this.showError = true;
        this.$noty.error('Login not successfull.');
        this.processing = false;
      });
    }
  }
}

</script>

<style scoped>

</style>
